import { of } from 'rxjs';
import { catchError, delay, retryWhen, scan, tap } from 'rxjs/operators';

export function focusItem(selector: string): void {
    of(null)
        .pipe(
            tap(() => {
                const el: HTMLInputElement = document.querySelector(selector);
                if (el != null) {
                    el.focus();
                }
            }),
            delay(250),
            tap(() => {
                const el: HTMLInputElement = document.querySelector(selector);
                if (document.activeElement !== el) {
                    throw new Error('not focused');
                }
            }),
            retryWhen((errors) =>
                errors.pipe(
                    delay(250),
                    scan((acc) => {
                        if (acc >= 4) {
                            throw new Error('retry failed');
                        }
                        return acc + 1;
                    }, 0),
                ),
            ),
            catchError(() => of(null)),
        )
        .subscribe();
}
